import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'
import './MaintenancePage.css'

const pcdueLogoCandidates = [
  '/pcdue%20logo.png',
  '/pcdue-logo.png',
  '/pcdue_logo.png',
]

const MaintenancePage = () => {
  const navigate = useNavigate()
  const { logout } = useAuthContext()
  const [pcdueLogoIndex, setPcdueLogoIndex] = useState(0)

  const activePcdueLogo = pcdueLogoCandidates[pcdueLogoIndex]

  const handlePcdueLogoError = () => {
    if (pcdueLogoIndex < pcdueLogoCandidates.length - 1) {
      setPcdueLogoIndex(prev => prev + 1)
    }
  }

  const handleLogout = () => {
    logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="maintenance-page">
      <div className="maintenance-backdrop-orb maintenance-orb-left" />
      <div className="maintenance-backdrop-orb maintenance-orb-right" />

      <section className="maintenance-card">
        <div className="maintenance-badge">
          Modalita manutenzione / Maintenance mode
        </div>
        <h1 className="maintenance-title">
          Stiamo regolando il motore / We are tuning the engine
        </h1>
        <p className="maintenance-subtitle">
          Manutenzione in corso. L'accesso e temporaneamente limitato agli utenti
          autorizzati mentre PCDUE e SFRE preparano la prossima release.
        </p>

        <div className="maintenance-joke">
          <span>Aggiornamento amichevole:</span> i nostri robot sono caffeinati
          e lavorano straordinario. Hanno chiesto altri 15 minuti, un espresso e
          un applauso.
        </div>

        <div className="maintenance-brand-row">
          <img
            src="/franca-logo.png"
            alt="SFRE FRANCA logo"
            className="maintenance-logo maintenance-logo-sfre"
          />
          <div className="maintenance-brand-divider" />
          <img
            src={activePcdueLogo}
            alt="PCDUE logo"
            className="maintenance-logo maintenance-logo-pcdue"
            onError={handlePcdueLogoError}
          />
        </div>

        <div className="maintenance-actions">
          <button type="button" onClick={() => navigate('/login')}>
            Torna al login / Back to login
          </button>
          <button type="button" className="secondary" onClick={handleLogout}>
            Esci / Logout
          </button>
        </div>
      </section>
    </div>
  )
}

export default MaintenancePage
